import { Col } from '@opendoor/atoms/box';
import { Link } from '@opendoor/atoms/link';
import { Text } from '@opendoor/atoms/text';
import type { EntryComponent } from 'cms/entries/entries';
import type { AddressSearchLocation } from 'components/globals';
import NewSellerFlowAddressInput from 'components/shared/NewSellerFlowAddressInput';
import type { ICompareFinalCta } from 'declarations/contentful';

const RenderCompareFinalCta = (entry: ICompareFinalCta) => {
  const { fields } = entry;

  return (
    <Col as="section" className="items-center bg-od-bg-inverse-primary py-25 max-md:py-16">
      <Col className="w-full max-w-280 items-center gap-10 px-6">
        <Col className="items-center gap-4">
          <Text
            as="h2"
            className="text-center text-subheader-lg text-od-content-inverse-primary max-md:text-subheader-md"
          >
            {fields.title}
          </Text>
          <Text
            as="p"
            className="max-w-120 text-center text-body-lg leading-relaxed text-od-content-inverse-secondary"
          >
            {fields.description}
          </Text>
        </Col>

        <Col className="w-full max-w-120 items-center gap-5">
          <Col className="w-full">
            <NewSellerFlowAddressInput
              hideLabel
              inputLocation={
                (fields.addressInputLocation || 'cta-standalone') as AddressSearchLocation
              }
              analyticsPrefix={fields.addressInputAnalyticsPrefix || 'compare-final'}
              trackingTaxonomy="new_homepage"
              placeholder={fields.addressInputPlaceholder || 'Enter your home address'}
              channel="DEFAULT"
              size="medium"
            />
          </Col>
          {fields.subtext && (
            <Text as="p" className="text-center text-body-sm text-od-content-inverse-tertiary">
              {fields.subtext}
            </Text>
          )}
        </Col>

        {fields.linkText && fields.linkUrl && (
          <Link
            href={fields.linkUrl}
            rel="noopener"
            analyticsName="compare-final-cta-link"
            className="text-body-sm !text-od-content-inverse-primary"
          >
            {fields.linkText}
          </Link>
        )}
      </Col>
    </Col>
  );
};

const CompareFinalCta: EntryComponent<ICompareFinalCta> = {
  render: RenderCompareFinalCta,
};

export default CompareFinalCta;
